import { createElement } from "react";
import { isHotkey } from "is-hotkey";
const boldMark = "isBold";
const boldMarkPlugin = {
  type: boldMark,
  isHotKey: isHotkey("mod+b"),
  render: ({ children }) => createElement("b", void 0, children)
};
export {
  boldMark,
  boldMarkPlugin
};
//# sourceMappingURL=boldMark.js.map
